import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import { pianoAnalytics } from 'piano-analytics-js';
import { logFn } from './utils';
import { whitelistedEvents, whitelistedProperties } from './helpers/whitelist';
var ACCEPTED_PRIVACY_MODES = ['exempt', 'optout'];
var wrappedAnalytics = {
  sendEvent: function sendEvent() {
    // Only send if configuration is set
    if (pianoAnalytics.getConfiguration('site')) {
      var _pianoAnalytics$sendE;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_pianoAnalytics$sendE = pianoAnalytics.sendEvent).call.apply(_pianoAnalytics$sendE, [pianoAnalytics].concat(args));
    }

    if (global.__DEV__) {
      logFn('sendEvent', 'No "site" configuration set: Aborting action.');
    }

    return undefined;
  },
  sendEvents: function sendEvents() {
    // Only send if configuration is set
    if (pianoAnalytics.getConfiguration('site')) {
      var _pianoAnalytics$sendE2;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_pianoAnalytics$sendE2 = pianoAnalytics.sendEvents).call.apply(_pianoAnalytics$sendE2, [pianoAnalytics].concat(args));
    }

    if (global.__DEV__) {
      logFn('sendEvents', 'No "site" configuration set: Aborting action.');
    }

    return undefined;
  },
  setProperties: function setProperties() {
    var _pianoAnalytics$setPr;

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return (_pianoAnalytics$setPr = pianoAnalytics.setProperties).call.apply(_pianoAnalytics$setPr, [pianoAnalytics].concat(args));
  }
};

function setConfiguration(trackingConfiguration) {
  var site = trackingConfiguration.site,
      collectDomain = trackingConfiguration.collectDomain,
      debug = trackingConfiguration.debug;
  pianoAnalytics.setConfigurations({
    site: site,
    collectDomain: collectDomain
  });
  pianoAnalytics.privacy.include.events(whitelistedEvents, ['exempt']); // Exemption des événements Sales Insights

  pianoAnalytics.privacy.include.properties(whitelistedProperties, ['exempt']); // Exemption des propriétés supplémentaires avec nos nouveaux SDK

  if (!ACCEPTED_PRIVACY_MODES.includes(pianoAnalytics.privacy.getMode())) {
    pianoAnalytics.privacy.setMode('exempt');
  }

  if (global.__DEV__ && debug) {
    var originalFn = _objectSpread({}, wrappedAnalytics);

    wrappedAnalytics.sendEvent = function () {
      try {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        logFn.apply(void 0, ['sendEvent'].concat(args));
        return originalFn.sendEvent.apply(originalFn, args);
      } catch (err) {
        return logFn('sendEvent err', err);
      }
    };

    wrappedAnalytics.sendEvents = function () {
      try {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }

        logFn.apply(void 0, ['sendEvents'].concat(args));
        return originalFn.sendEvents.apply(originalFn, args);
      } catch (err) {
        return logFn('sendEvents err', err);
      }
    };

    wrappedAnalytics.setProperties = function () {
      try {
        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }

        logFn.apply(void 0, ['setProperties'].concat(args));
        return originalFn.setProperties.apply(originalFn, args);
      } catch (err) {
        return logFn('setProperties err', err);
      }
    };
  }

  return {
    site: pianoAnalytics.getConfiguration('site'),
    collectDomain: pianoAnalytics.getConfiguration('collectDomain')
  };
}

export { setConfiguration, wrappedAnalytics };